export default __webpack_public_path__ + "f331a0bfedb8e56a305900f811580f9b.svg";